
import React from 'react';
import { Button } from '@/components/ui/button';
import { Globe, X } from 'lucide-react';

interface LoadingHeaderProps {
  websiteUrl: string;
  favicon: string | null;
  onCancel: () => void;
}

const LoadingHeader: React.FC<LoadingHeaderProps> = ({ websiteUrl, favicon, onCancel }) => {
  return (
    <div className="flex items-start justify-between mb-6">
      <div className="flex items-center gap-3">
        {favicon ? (
          <img 
            src={favicon} 
            alt="Website favicon" 
            className="w-6 h-6 rounded-sm object-contain"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
            }}
          />
        ) : (
          <Globe className="w-5 h-5 text-muted-foreground" />
        )}
        <div>
          <h2 className="text-xl font-semibold mb-1">Analyzing Website</h2>
          <p className="text-muted-foreground text-sm break-all">
            {websiteUrl}
          </p>
        </div>
      </div>
      <Button
        variant="ghost"
        size="icon"
        onClick={onCancel}
        className="text-muted-foreground hover:text-foreground"
      >
        <X size={18} />
        <span className="sr-only">Cancel</span>
      </Button>
    </div>
  );
};

export default LoadingHeader;
